import { Empty, Spin } from "antd";
import { useTranslation } from "react-i18next";

export type ProfileTabEmptyKey =
  | "orders"
  | "invoices"
  | "cars"
  | "loyalty"
  | "wallet";

interface ProfileTabStateProps {
  /** True while list data is being fetched (Redux `idle` / initial load). */
  loading: boolean;
  /** True when fetch finished and there is nothing to show. */
  empty: boolean;
  emptyKey: ProfileTabEmptyKey;
  children: React.ReactNode;
}

/**
 * Shared loading + empty UI for profile section tabs (orders, invoices, cars, histories).
 */
const ProfileTabState = ({
  loading,
  empty,
  emptyKey,
  children,
}: ProfileTabStateProps) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="ac-profile-tab-state ac-profile-tab-state--loading">
        <Spin size="large" />
        <p className="ac-profile-tab-state__hint ac--font-expo">
          {t("profile.loading")}
        </p>
      </div>
    );
  }

  if (empty) {
    return (
      <div className="ac-profile-tab-state ac-profile-tab-state--empty">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span className="ac-profile-tab-state__empty-text ac--font-expo">
              {t(`profile.empty.${emptyKey}`)}
            </span>
          }
        />
      </div>
    );
  }

  return <>{children}</>;
};

export default ProfileTabState;
